<app-page-header [pageTitle]="'Create, edit and manage your sample playlists'"></app-page-header>
<div class="top_box">
    <div class="mf_buttons">
        <div class="search_box">
            <form method="get" #searchForm="ngForm">
                <input type="text" name="search" (focus)="focusInput()" (blur)="blurInput()" value="{{ searchStr }}"
                    placeholder="Playlist search" class="searchInput" [(ngModel)]="searchStr" maxlength="30" />
                <button type="submit" class="searchBtn" (click)="search($event)"></button>
                <a href="#" class="clear_search" (click)="clearSearch($event)"></a>
            </form>
        </div>
        <button *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')"
            class="create_category_btn" (click)="openCategoriesPopup($event, null)" title="New Category">Create New
            Category</button>

        <button class="create_subcategory_btn" (click)="openSitePopup($event,null)"
            *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')"
            title="New Subcategory">Create New sub category</button>
        <button *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')"
            class="create_playlist_btn" (click)="openPlaylistPopup($event,null)" title="New Playlist">Create 
            foundation Playlist</button>

    </div>
</div>

<div class="foundation_playlist_main">
    <div class="breadcrumbs">
        <a href="#" (click)="resetCheckedElements(1)">Foundation Sample Playlists</a>
        <a href="#" *ngIf="checkedUserId.name!=''" (click)="resetCheckedElements(2)">{{checkedUserId.name}}</a>
        <a href="#" *ngIf="checkedSiteId.name!=''" (click)="resetCheckedElements(3)">{{checkedSiteId.name}}</a>
        <a href="#" *ngIf="checkedChanelId.name!=''" (click)="resetCheckedElements(4)">{{checkedChanelId.name}}</a>

    </div>
    <div class="left_block"
        [ngStyle]="tabs.selected && {'width':'210px'}">
        <div class="users_block box">
            <ul>
                <li *ngFor="let u of usersList" (click)="clickedInside($event,u.id)"
                    [ngClass]="{opened: checkedUserId.id == u.id}" id="user-list-{{u.id}}">
                    <span contentType="template" (click)="getSites(u.id, u.name ,1)">{{u.name}}</span>
                    <div class="actions_wrap">
                        <a href="#" class="arrow" (click)="getSites(u.id, u.name ,1)"></a>
                    </div>
                </li>
            </ul>

        </div>
        <div class="playlists_block box"
            *ngIf="checkedUserId.id!=null && !tabs.selected">
            <ul *ngIf="sitesList!=null">
                <li *ngFor="let site of sitesList" (click)="clickedInside($event)"
                    [ngClass]="{opened: checkedSiteId.id == site.id}">
                    <!-- , site_hidden: checkEntityFilterSite(site) -->
                    <div class="wrap">
                        <!-- <ng-template #SitePopupContent>
                            <span style="font-size: 12px !important;">Entity ID : {{site.entity_id}} <br>
                                Parent Entity ID : {{site.parent_entity_id}} <br>
                                Parent Entity Name : {{site.parent_entity_name}} <br>
                                Total tracks : {{site.total_tracks}}
                            </span>
                        </ng-template> -->
                        <span contentType="template"
                            (click)="showChanels($event,site.id,site.name,1)">{{site.name}}</span>

                    </div>
                    <div class="actions_wrap">
                        <a href="#" class="arrow" (click)="showChanels($event,site.id,site.name,1)"></a>
                        <ul class="actions_popup"
                            *ngIf="isShowActions.number==2&&current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')">
                            <li>
                                <a href="#" class="playlist_categories_edit"
                                    (click)="openSitePopup($event,site.id)"></a>
                            </li>
                            <li>
                                <a href="#" class="playlist_categories_delete"
                                    (click)="openConfirmPopup( site.id, 1)"></a>
                            </li>
                            <!-- <li>
                                <a href="#"
                                    *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')"
                                    class="playlist_restore" (click)="openFileUploadPopup(site.id)"></a>
                            </li> -->
                        </ul>
                    </div>
                    <ul *ngIf="site.children !=0">
                        <li *ngFor="let chanel of site.children" (click)="clickedInside($event)"
                            [ngClass]="{opened: checkedChanelId.id == chanel.id}">
                            <!-- <ng-template #ChannelPopupContent>
                                <span style="font-size: 12px;">Entity ID : {{chanel.entity_id}} <br>
                                    Parent Entity ID : {{site.entity_id}} <br>
                                    Parent Entity Name : {{site.name}} <br>
                                    Total Tracks : {{chanel.countDetails.clip_count}}
                                </span>
                            </ng-template> -->
                            <span [tooltip]="ChannelPopupContent" [options]="tooltipOptions" contentType="template"
                                (click)="showPlaylists($event,chanel.id,chanel.name, 1)">{{chanel.name}}</span>
                            <div class="actions_wrap">
                                <a href="#" class="arrow" (click)="showPlaylists($event,chanel.id,chanel.name, 1)"></a>
                                <ul class="actions_popup"
                                    *ngIf="isShowActions.number==3&&current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')">
                                    <li>
                                        <a href="#" class="playlist_categories_edit"
                                            (click)="openChanelsPopup($event,chanel.id)"></a>
                                    </li>
                                    <li>
                                        <a href="#" class="playlist_categories_delete"
                                            (click)="openConfirmPopup( chanel.id, 2)"></a>
                                    </li>
                                    <li>
                                        <a href="#" class="playlist_categories_restore"
                                            (click)="openRestoredDatesPopup($event,chanel.id)"></a>
                                    </li>

                                </ul>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="playlists_block box" *ngIf="entitySearchResult.length > 0">
            <ul>
                <li *ngFor="let site of entitySearchResult" (click)="clickedInside($event)"
                    [ngClass]="{opened: checkedSiteId.id == site.id}">
                    <div class="wrap">
                        <ng-template #SitePopupContent>
                            <span style="font-size: 12px !important;">Entity ID : {{site.entity_id}} <br>
                                Parent Entity ID : {{site.parent_entity_id}} <br>
                                Parent Entity Name : {{site.parent_entity_name}} <br>
                                Total tracks : {{site.total_tracks}}
                            </span>
                        </ng-template>
                        <span [tooltip]="SitePopupContent" [options]="tooltipOptions"
                            (click)="showChanels($event,site.id,site.name,1)"
                            contentType="template">{{site.name}}</span>

                    </div>
                    <div class="actions_wrap">
                        <a href="#" class="arrow" (click)="showChanels($event,site.id,site.name,1)"></a>
                        <ul class="actions_popup"
                            *ngIf="isShowActions.number==2&&current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')">
                            <li>
                                <a href="#" class="playlist_categories_edit"
                                    (click)="openSitePopup($event,site.id)"></a>
                            </li>
                            <li>
                                <a href="#" class="playlist_categories_delete"
                                    (click)="openConfirmPopup( site.id, 1)"></a>
                            </li>
                            <li>
                                <a href="#"
                                    *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')"
                                    class="playlist_categories_upload" (click)="openFileUploadPopup(site.id)"></a>
                            </li>
                        </ul>
                    </div>
                    <ul *ngIf="site.children !=undefined">
                        <li *ngFor="let channel of site.children" (click)="clickedInside($event)"
                            [ngClass]="{opened: checkedChanelId.id == channel.id}">
                            <ng-template #ChannelPopupContentAlpha>
                                <span style="font-size: 12px;">Entity ID : {{channel.entity_id}} <br>
                                    Parent Entity ID : {{site.entity_id}}<br>
                                </span>
                            </ng-template>
                            <span [tooltip]="ChannelPopupContentAlpha" [options]="tooltipOptions" contentType="template"
                                (click)="showPlaylists($event,channel.id,channel.name, 1)">{{channel.name}}</span>
                            <div class="actions_wrap">
                                <a href="#" class="arrow"
                                    (click)="showPlaylists($event,channel.id,channel.name, 1)"></a>
                                <ul class="actions_popup"
                                    *ngIf="isShowActions.number==3&&current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')">
                                    <li>
                                        <a href="#" class="playlist_categories_edit"
                                            (click)="openChanelsPopup($event,channel.id)"></a>
                                    </li>
                                    <li>
                                        <a href="#" class="playlist_categories_delete"
                                            (click)="openConfirmPopup( channel.id, 2)"></a>
                                    </li>
                                    <li>
                                        <a href="#" class="playlist_categories_restore"
                                            (click)="openRestoredDatesPopup($event,channel.id)"></a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>



    <div class="playlists_list_block" *ngIf="current_user!=undefined&&checkedSiteId.id != null"
        [ngClass]="{'client_playlist_block': current_user.type != 'Administrator' && current_user.type != 'Manager' && current_user.type != 'Consultant'}"
        [ngStyle]="entitySearchResult.length > 0 ">
        <ul class="tabs">
            <li [ngClass]="{selected: channeltabs.selected == 1}" (click)="selectTab(1)">Live Samples</li>
            <li [ngClass]="{selected: channeltabs.selected == 2}" (click)="selectTab(2)">Archived Samples</li>
        </ul>
        <div class="table_wrap" [ngClass]="{selected: channeltabs.selected == 1}">
            <div class="table_titles">
                <div class="order" (click)="setOrderTC('name')" [ngClass]="{active: orderBy=='name',asc:order=='ASC'}">
                    Name</div>
                    <div class="order" (click)="setOrderTC('editor')"
                    [ngClass]="{active: orderBy=='created_at',asc:order=='ASC'}">Editor</div>
                <div class="order" (click)="setOrderTC('created_at')"
                    [ngClass]="{active: orderBy=='created_at',asc:order=='ASC'}">Date Added</div>
                <div class="order" (click)="setOrderTC('updated_at')"
                    [ngClass]="{active: orderBy=='updated_at',asc:order=='ASC'}">Date Updated</div>
                <div># of Tracks</div>
                <div class="order" (click)="setOrderTC('status')"
                    [ngClass]="{active: orderBy=='status',asc:order=='ASC'}">Status</div>
                <div>Functions</div>
                <div>Actions</div>
            </div>
            <div class="table_content">
                <div *ngFor="let p of playlists">
                    <div class="table_row"
                        [ngClass]="{'highlight': p.profile_type == 1 && (p.sync == 0 || p.schedule?.sync == 0)}"
                        *ngIf="p.profile_name!='temp_profile'">
                        <div>
                            <!-- <ng-template #MasterTooltipContent>
                                <span style="font-size: 12px !important;" *ngIf="p.name">Distribution group :
                                    {{p.}}<name/span>
                            </ng-template>
    
                            <span [options]="tooltipOptions" [tooltip]="MasterTooltipContent" contentType="template"
                                *ngIf="p.profile_type == 1" class="master_icon"></span> -->

                            {{p.name}}
                        </div>
                        <div>{{p.user.first_name}}</div>
                        <div>{{p.created_at | date:'Y-MM-dd hh:mm:ss'}}</div>
                        <div>{{p.updated_at | date:'Y-MM-dd hh:mm:ss'}}</div>

                        <div>{{p.files_count}}</div>
                        <div>
                            <select id="Id" #Id="ngModel" class="custom-select hideLabel form-control"
                                [(ngModel)]="p.status" name="Id" style="width: 90px;margin-left: 15px;"
                                (change)="statusChange($event,p.id)">
                                <option value="0">LIVE</option>
                                <option value="1">EDITING</option>
                                <option value="2">ARCHIVE</option>
                            </select>
                        </div>
                        <div>
                            <a *ngIf="p.profile_type != 2" class="playlist_manage" title="Manage"  (click)="manageClick(p.id)" routerLink="/manage-sample-foundation-playlist">Manage</a>
                        </div>
                        <div>
                            <div class="copy_wrap"
                            *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')">
                            <a  class="dg_icon"  title="Copy" href="#"
                                (click)="openPopUpforCopy(p.id)"></a>
                            </div> 
                            <div class="editing_wrap"
                                *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')">
                                <a class="playlist_edit" title="Edit" href="#"
                                    (click)="openPlaylistPopup($event,p.id)"></a>
                            </div>
                         
                            <a class="playlist_delete" title="Delete"
                                *ngIf="current_user!=null &&(current_user.type=='Consultant'||current_user.type=='Administrator')"    href="#"
                                (click)="openConfirmPopup(p.id,3)"></a>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--For Show Archive data -->

        <div class="table_wrap" [ngClass]="{selected: channeltabs.selected == 2}">
            <div class="table_titles">
                <div>Name</div>
                <div>Editor</div>
                <div>Date Added</div>
                <div>Date Updated</div>
                <div># of Tracks</div>
                <div>Status</div>
                <div>Functions</div>
                <div>Actions</div>
            </div>
            <div class="table_content">
                <div *ngFor="let p of archivePlaylists">
                    <div class="table_row"
                        [ngClass]="{'highlight': p.profile_type == 1 && (p.sync == 0 || p.schedule?.sync == 0)}"
                        *ngIf="p.profile_name!='temp_profile'">
                        <div>
                            <!-- <ng-template #MasterTooltipContent>
                                <span style="font-size: 12px !important;" *ngIf="p.name">Distribution group :
                                    {{p.}}<name/span>
                            </ng-template>
    
                            <span [options]="tooltipOptions" [tooltip]="MasterTooltipContent" contentType="template"
                                *ngIf="p.profile_type == 1" class="master_icon"></span> -->

                            {{p.name}}
                        </div>
                        <div>{{p.user.first_name}}</div>
                        <div>{{p.created_at | date:'Y-MM-dd hh:mm:ss'}}</div>
                        <div>{{p.updated_at | date:'Y-MM-dd hh:mm:ss'}}</div>

                        <div>{{p.files_count}}</div>
                        <div>
                            <select id="Id" #Id="ngModel" class="custom-select hideLabel form-control"
                                [(ngModel)]="p.status" name="Id" style="width: 90px;"
                                (change)="statusChange($event,p.id)">
                                <option value="0">LIVE</option>
                                <option value="1">EDITING</option>
                                <option value="2">ARCHIVE</option>
                            </select>
                        </div>
                        <div>
                            <a *ngIf="p.profile_type != 2" class="playlist_manage" title="Manage"
                                (click)="manageClick(p.id)" routerLink="/manage-sample-foundation-playlist">Manage</a>
                        </div>
                        <div>

                            <div class="editing_wrap"
                                *ngIf="current_user!=null&&(current_user.type=='Consultant'||current_user.type=='Administrator')">
                                <a class="playlist_edit" title="Edit" href="#"
                                    (click)="openPlaylistPopup($event,p.id)"></a>
                            </div>                            
                            
                            <a class="playlist_delete" title="Delete"
                                *ngIf="p.uid == '' && current_user!=null &&(current_user.type=='Consultant'||current_user.type=='Administrator')"
                                href="#"
                                (click)="(p.profile_type == 0 || p.profile_type == 1) && openConfirmPopup(p.id,3)"></a>
                            <a class="playlist_delete disabled" title="Delete"
                                *ngIf="p.uid != '' && current_user!=null &&(current_user.type=='Consultant'||current_user.type=='Administrator')"></a>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>


</div>

<!-- PopUpOpen for create Category-->

<div class="popup create_category_popup" [ngClass]="{ opened: categoriesPopupOpened }" ngDraggable ngResizable
    [rzHandles]="'n,e,s,w,se,sw,ne,nw'" [handle]="dragHandle">
    <a href="#" class="popup_close" (click)="popupClose($event)"></a>
    <div class="popup_title" #dragHandle>Create/Edit Category</div>
    <div class="popup_form">
        <form #updateCategories="ngForm">
            <input type="hidden" name="user" value="{{ categoriesFields.user}}" [(ngModel)]="categoriesFields.user" />
            <div class="input_wrap">
                <label>Name</label>
                <input autocomplete="off" type="text" maxlength="50" name="name" value="{{ categoriesFields.name }}"
                    [(ngModel)]="categoriesFields.name" />
            </div>
            <div class="popup_btns">
                <button type="button" class="cancel" (click)="popupClose($event)">
                    Cancel
                </button>
                <button type="submit" (click)="categoryUpdate($event, updateCategories)">Save</button>
            </div>
        </form>
    </div>
</div>


<!--For Create new playlist popup and edit popup-->

<div class="popup create_playlist_popup" [ngClass]="{opened: create_new_playlistpopUp}" ngDraggable ngResizable
    [rzHandles]="'n,e,s,w,se,sw,ne,nw'" [handle]="dragHandle">
    <a href="#" class="popup_close" (click)="popupClose($event)"></a>
    <div class="popup_title" #dragHandle>Create/Edit Playlist</div>
    <div class="popup_form">
        <form #updatePlaylist="ngForm">
            <input type="hidden" name="status" value="playlistFields.status" [(ngModel)]="playlistFields.status">
            <input type="hidden" name="edited_by" value=current_user.id [(ngModel)]="playlistFields.edited_by">
            <input type="hidden" name="user_id" *ngIf="playlistFields.id != null" value="{{playlistFields.user}}"
                [(ngModel)]="playlistFields.user" />
            <div class="input_wrap">
                <label>Name</label>
                <input autocomplete="off" style="width: 50%;height: 20px;border: 1px solid #b8b9bb;font-family: 'Brandon', Arial, sans-serif;
                ;font-size: 10px;
          padding: 0 5px;" type="text" maxlength="50" name="name" value="{{playlistFields.name}}"
                    [(ngModel)]="playlistFields.name" />
            </div>
            <div class="input_wrap" *ngIf="playlistFields.id == null">
                <label>Category</label>
                <select name="client_id" *ngIf="usersList!=null" [(ngModel)]="playlistFields.user"
                    (change)="userChange($event,2)">
                    <option [ngValue]="null" [selected]="playlistFields.user==null">Select Category...</option>
                    <option *ngFor="let u of usersList" value="{{u.id}}" [selected]="playlistFields.user == u.id">
                        {{u.name}}</option>
                </select>
            </div>

            <div class="input_wrap" *ngIf="playlistFields.id == null">
                <label>Sub-Category</label>
                <select name="site_id" [(ngModel)]="playlistFields.site">
                    <option [ngValue]="null" [selected]="playlistFields.site==null">Select SubCategory...</option>
                    <option *ngFor="let site of playlistFields.sitesList" [ngValue]="site.id"
                        [selected]="playlistFields.site==site.id">{{site.name}}</option>
                </select>
            </div>
            <div class="popup_btns">
                <button type="button" class="cancel" (click)="popupClose($event)">Cancel</button>
                <button type="submit" (click)="playlistUpdate($event,updatePlaylist,0)">Save & Close</button>
                <!-- <button type="submit">Save & Manage</button> -->
            </div>
        </form>
    </div>
</div>

<!--for create and edit sub category part -->


<div class="popup create_site_popup" [ngClass]="{opened: sitePopupOpened}" ngDraggable ngResizable
    [rzHandles]="'n,e,s,w,se,sw,ne,nw'" [handle]="dragHandle2">
    <a href="#" class="popup_close" (click)="popupClose($event)"></a>
    <div class="popup_title" #dragHandle2>
        <span *ngIf="subcategoryFields.id!=null">Edit Subcategory</span>
        <span *ngIf="subcategoryFields.id==null">Create New Subcategory</span>
    </div>
    <div class="popup_form">
        <form #updateSite="ngForm">
            <input type="hidden" name="visible" value="{{subcategoryFields.visible}}"
                [(ngModel)]="subcategoryFields.visible">
            <input type="hidden" name="user_id" value="{{subcategoryFields.user_id}}"
                [(ngModel)]="subcategoryFields.user_id" />
          
                <div class="input_wrap">
                    <label>Name</label>
                    <input autocomplete="off" type="text" maxlength="50" name="name" value="{{subcategoryFields.name}}"
                        [(ngModel)]="subcategoryFields.name" />
                </div>
                <div class="input_wrap" *ngIf="subcategoryFields.id == null">
                    <label>Category</label>
                    <select name="category" [(ngModel)]="subcategoryFields.category">
                        <option value="null" [selected]="subcategoryFields.category==null">Select Category...</option>
                        <option *ngFor="let u of usersList" value="{{u.id}}"
                            [selected]="subcategoryFields.category==u.id">{{u.name}}</option>
                    </select>
                </div>
            
            <div class="popup_btns">
                <button type="button" class="cancel" (click)="popupClose($event)">Cancel</button>
                <button type="submit" (click)="subcategory($event, updateSite)">Save</button>
            </div>
        </form>
    </div>
</div>

<!--For Copy playlist -->

<div class="popup create_playlist_popup" [ngClass]="{opened: copyFpSamplePlaylist}" ngDraggable ngResizable
    [rzHandles]="'n,e,s,w,se,sw,ne,nw'" [handle]="dragHandle">
    <a href="#" class="popup_close" (click)="popupClose($event)"></a>
    <div class="popup_title" #dragHandle>Create/Edit Playlist</div>
    <div class="popup_form">
        <form #copyfpsamplePlaylist="ngForm">
            <input type="hidden" name="status" value="copyFields.status" [(ngModel)]="copyFields.status">
            <input type="hidden" name="edited_by" value=current_user.id [(ngModel)]="copyFields.edited_by">
            <input type="hidden" name="user_id" *ngIf="copyFields.id != null" value="{{copyFields.user}}"
                [(ngModel)]="copyFields.user" />
         
            <div class="input_wrap" >
                <label>Category</label>
                <select name="client_id" *ngIf="usersList!=null" [(ngModel)]="copyFields.user"
                    (change)="userChange($event,3)">
                    <option value="null" [selected]="copyFields.user==null">Select Category...</option>
                    <option *ngFor="let u of usersList" value="{{u.id}}" [selected]="copyFields.user == u.id">
                        {{u.name}}</option>
                </select>
            </div>

            <div class="input_wrap" >
                <label>Sub-Category</label>
                <select name="site_id" [(ngModel)]="copyFields.site">
                    <option value="null" [selected]="copyFields.site==null">Select SubCategory...</option>
                    <option *ngFor="let site of copyFields.sitesList" value="{{site.id}}"
                        [selected]="copyFields.site==site.id">{{site.name}}</option>
                </select>
            </div>
            <div class="input_wrap">
                <label>Name</label>
                <input autocomplete="off" style="width: 50%;height: 20px;border: 1px solid #b8b9bb;font-family: 'Brandon', Arial, sans-serif;font-size: 10px;
          padding: 0 5px;" type="text" maxlength="50" name="name" value="{{copyFields.name}}"
                    [(ngModel)]="copyFields.name" />
            </div>
            <div class="popup_btns">
                <button type="button" class="cancel" (click)="popupClose($event)">Cancel</button>
                <button type="submit" (click)="fpSamplePlaylistCopy($event,copyfpsamplePlaylist,0)">Copy</button>
                <!-- <button type="submit">Save & Manage</button> -->
            </div>
        </form>
    </div>
</div>

<app-alert></app-alert>
<app-confirm (isConfirm)="isConfirm($event)"></app-confirm>